import React from 'react';

export const BottomNav = ({ activeTab, onTabChange, notifications = {} }) => {
  const navItems = [
    {
      id: 'positions',
      label: 'Positions',
      icon: (
        <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
          <path d="M3 3h18v18H3V3zm2 2v14h14V5H5zm2 2h10v2H7V7zm0 4h10v2H7v-2zm0 4h7v2H7v-2z"/>
        </svg>
      )
    },
    {
      id: 'risk',
      label: 'Risk',
      icon: (
        <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
          <path d="M12 2L2 7v10c0 5.55 3.84 9.74 9 11 5.16-1.26 9-5.45 9-11V7l-10-5zm0 2.18L20 8.09v8.91c0 4.54-3.2 7.92-8 9.05-4.8-1.13-8-4.51-8-9.05V8.09l8-3.91z"/>
        </svg>
      )
    },
    {
      id: 'history',
      label: 'History',
      icon: (
        <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
          <path d="M13 3c-4.97 0-9 4.03-9 9H1l3.89 3.89.07.14L9 12H6c0-3.87 3.13-7 7-7s7 3.13 7 7-3.13 7-7 7c-1.93 0-3.68-.79-4.94-2.06l-1.42 1.42C8.27 19.99 10.51 21 13 21c4.97 0 9-4.03 9-9s-4.03-9-9-9zm-1 5v5l4.28 2.54.72-1.21-3.5-2.08V8H12z"/>
        </svg>
      )
    },
    {
      id: 'analysis',
      label: 'Analysis',
      icon: (
        <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
          <path d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM9 17H7v-7h2v7zm4 0h-2V7h2v10zm4 0h-2v-4h2v4z"/>
        </svg>
      )
    }
  ];

  const handleTabClick = (tabId) => {
    if (onTabChange) {
      onTabChange(tabId);
    }
    
    // Show appropriate content based on tab
    switch (tabId) {
      case 'positions':
        // This would typically open a positions modal or navigate
        console.log('Opening positions view');
        break;
      case 'risk':
        // This would typically open a risk management view
        console.log('Opening risk management view');
        break;
      case 'history':
        // This would typically open a trade history view
        console.log('Opening trade history view');
        break;
      case 'analysis':
        // This would typically open an analysis view
        console.log('Opening analysis view');
        break;
      default:
        break;
    }
  };

  return (
    <div className="fixed bottom-0 left-0 right-0 bg-gradient-to-r from-atticus-navy-900 to-atticus-navy-800 border-t border-yellow-400/20 shadow-lg z-40">
      <div className="flex">
        {navItems.map((item) => (
          <button
            key={item.id}
            onClick={() => handleTabClick(item.id)}
            className={`flex-1 py-3 px-2 flex flex-col items-center justify-center space-y-1 transition-all duration-200 relative ${
              activeTab === item.id 
                ? 'text-yellow-400 bg-yellow-400/10' 
                : 'text-gray-400 hover:text-white hover:bg-white/5'
            }`}
          >
            <div className="relative">
              {item.icon}
              {notifications[item.id] && (
                <div className="absolute -top-2 -right-2 bg-red-500 text-white text-xs rounded-full h-5 w-5 flex items-center justify-center animate-pulse">
                  {notifications[item.id]}
                </div>
              )}
            </div>
            <span className="text-xs font-medium">{item.label}</span>
            {activeTab === item.id && (
              <div className="absolute bottom-0 left-1/2 transform -translate-x-1/2 w-8 h-0.5 bg-yellow-400 rounded-full"></div>
            )}
          </button>
        ))}
      </div>
    </div>
  );
};
